// @flow
import React from "react";
import styled from "styled-components";

const Cup = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 28 35"
    fill={props.fill ? props.fill : "currentColor"}
  >
    <path
      d="M716.27 464h3.8v9.3h-1c-.6 0-1.13-.23-1.58-.7l-1.29-1.31c-.46-.4-.68-1.01-.68-1.63v-4.88c0-.47.3-.78.75-.78zm18.95 9.3V464H739c.45 0 .75.31.75.78v4.88c0 .62-.22 1.16-.68 1.63l-1.29 1.31c-.37.47-.98.7-1.59.7zm2.27 18.6c.38 0 .76-.4.76-.8v-1.59c0-.4-.38-.8-.76-.8h-.76v-3.78c0-.86-.68-1.56-1.51-1.56h-2.27v-.66c0-.5-.3-.82-.76-.82s-.76-.33-.76-.82v-2.56a5.31 5.31 0 0 0 3.57-3.66h1.2a3.4 3.4 0 0 0 2.65-1.16l1.3-1.32c.75-.7 1.13-1.7 1.13-2.71v-4.88c0-1.32-.99-2.33-2.27-2.33h-3.8v-1.43c.84 0 1.52-.72 1.52-1.61 0-.88-.68-1.61-1.51-1.61h-15.16c-.83 0-1.51.73-1.51 1.61 0 .89.68 1.61 1.51 1.61v1.43h-3.79c-1.28 0-2.27 1-2.27 2.33v4.88c0 1.08.38 2.01 1.14 2.71l1.29 1.32a3.52 3.52 0 0 0 2.65 1.16h1.2a5.32 5.32 0 0 0 3.57 3.66v2.56c0 .49-.3.82-.76.82-.45 0-.75.33-.75.82v.66h-2.28c-.83 0-1.51.7-1.51 1.56v3.78h-.76c-.38 0-.76.4-.76.8v1.6c0 .4.38.79.76.79z"
      transform="translate(-714 -457)"
    />
  </svg>
);

const Timer = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 27 33"
    fill={props.fill ? props.fill : "currentColor"}
  >
    <path
      d="M258.33 765.53a8.22 8.22 0 0 0-8.22-8.13h-.06v8.13zm-8.22-9.88c5.5 0 9.97 4.47 9.97 9.95a9.97 9.97 0 0 1-19.93 0 9.97 9.97 0 0 1 9.96-9.95zm-13.1 9.95a13.12 13.12 0 0 0 26.22 0c0-3.7-1.55-7.05-4.04-9.44l1.44-2.02a.81.81 0 0 0-.2-1.14l-2.16-1.53a.82.82 0 0 0-1.14.2l-1.47 2.07a12.86 12.86 0 0 0-3.48-1.06v-.85c0-.53.45-.98.99-.98h.54a1 1 0 0 0 .98-.98v-2.99a.99.99 0 0 0-.98-.98h-7.19a.99.99 0 0 0-.99.98v3a1 1 0 0 0 .99.97h.54c.54 0 .99.45.99.98v.85c-1.32.2-2.56.6-3.71 1.17l-1.46-2.05a.82.82 0 0 0-1.14-.2l-2.16 1.53a.8.8 0 0 0-.2 1.14l1.47 2.07a13.04 13.04 0 0 0-3.85 9.26z"
      transform="translate(-237 -746)"
    />
  </svg>
);

export { Cup, Timer };

const CupSvg = styled.svg.attrs({
  style: ({ width, height }) => ({
    width,
    height
  })
})`
  width: 28px;
  height: auto;

  @media (max-width: 959px) {
    width: 22px;
  }
`;

type Props = {
  width?: string,
  height?: string
};

export function CupIcon(props: Props) {
  return (
    <CupSvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.008 34.232"
      {...props}
    >
      <g transform="translate(-46.545 0.001)">
        <path
          fill="#9792a1"
          d="M135.035,385.556A1.561,1.561,0,0,0,133.479,384h-15.56a1.561,1.561,0,0,0-1.556,1.556v3.89h18.672Z"
          transform="translate(-65.15 -358.327)"
        />
        <path
          fill="#7c7688"
          d="M114.1,465.455a.837.837,0,0,1,.778.778v1.556a.837.837,0,0,1-.778.778H93.869a.837.837,0,0,1-.778-.778v-1.556a.837.837,0,0,1,.778-.778Z"
          transform="translate(-43.434 -434.336)"
        />
        <path
          fill="#f6b545"
          d="M184.66,314.036a.735.735,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v2.567a.735.735,0,0,1-.778.778.735.735,0,0,0-.778.778v.778h10.892v-.778A.735.735,0,0,0,184.66,314.036Z"
          transform="translate(-119.443 -289.919)"
        />
        <path
          fill="#787382"
          d="M319.627,389.446v-3.89A1.561,1.561,0,0,0,318.071,384h-3.89v5.446Z"
          transform="translate(-249.742 -358.327)"
        />
        <path
          fill="#ffcb5b"
          d="M193.961,410.384h-6.224a1.561,1.561,0,0,1-1.556-1.556h0a1.561,1.561,0,0,1,1.556-1.556h6.224a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,193.961,410.384Z"
          transform="translate(-130.3 -380.043)"
        />
        <g transform="translate(59.771 27.229)">
          <path
            fill="#f6b545"
            d="M245.92,410.385h-1.556l1.556-3.112h1.556Z"
            transform="translate(-244.364 -407.273)"
          />
          <path
            fill="#f6b545"
            d="M282.384,408.828a1.561,1.561,0,0,0-1.556-1.556l-1.556,3.112h1.556A1.56,1.56,0,0,0,282.384,408.828Z"
            transform="translate(-276.938 -407.272)"
          />
        </g>
        <path
          fill="#635d6e"
          d="M114.1,465.455h-5.446v.778a1.561,1.561,0,0,1-1.556,1.556H94.648a.735.735,0,0,1-.778-.778v-1.556a.735.735,0,0,0-.778.778v1.556a.78.78,0,0,0,.778.778H114.1a.837.837,0,0,0,.778-.778v-1.556A.837.837,0,0,0,114.1,465.455Z"
          transform="translate(-43.435 -434.336)"
        />
        <path
          fill="#ffcb5b"
          d="M186.571,360.727H188.9a.368.368,0,0,1,.389.389h0a.367.367,0,0,1-.389.389h-2.334a.367.367,0,0,1-.389-.389h0A.368.368,0,0,1,186.571,360.727Z"
          transform="translate(-130.301 -336.61)"
        />
        <path
          fill="#f6b545"
          d="M53.547,82.267H51.758A3.649,3.649,0,0,1,49.035,81.1l-1.323-1.323a3.532,3.532,0,0,1-1.167-2.723v-4.9a2.292,2.292,0,0,1,2.334-2.334h3.89a.778.778,0,0,1,0,1.556h-3.89a.735.735,0,0,0-.778.778v4.9a2.119,2.119,0,0,0,.7,1.634l1.323,1.323a2.239,2.239,0,0,0,1.634.7h1.789a.778.778,0,0,1,0,1.556Z"
          transform="translate(0 -65.152)"
        />
        <path
          fill="#f6b545"
          d="M351.658,82.268h-1.789a.778.778,0,1,1,0-1.556h1.789a2.119,2.119,0,0,0,1.634-.7l1.323-1.323a2.239,2.239,0,0,0,.7-1.634v-4.9a.735.735,0,0,0-.778-.778h-3.89a.778.778,0,1,1,0-1.556h3.89a2.292,2.292,0,0,1,2.334,2.334v4.9a3.649,3.649,0,0,1-1.167,2.723L354.381,81.1A3.532,3.532,0,0,1,351.658,82.268Z"
          transform="translate(-282.318 -65.153)"
        />
        <g transform="translate(66.773 4.667)">
          <path
            fill="#f19920"
            d="M352.2,231.564c-.156,0-.311.078-.545.078h-1.789a.778.778,0,1,0,0,1.556h2.1a5.529,5.529,0,0,0,.233-1.634Z"
            transform="translate(-349.091 -220.75)"
          />
          <path
            fill="#f19920"
            d="M360.727,70.6a.735.735,0,0,0,.778.778h1.556V69.818H361.5A.735.735,0,0,0,360.727,70.6Z"
            transform="translate(-359.949 -69.818)"
          />
        </g>
        <path
          fill="#ffca5d"
          d="M149.75,64.439h-4.668a5.413,5.413,0,0,1-5.446-5.446V46.545H155.2V58.993A5.412,5.412,0,0,1,149.75,64.439Z"
          transform="translate(-86.867 -43.434)"
        />
        <g transform="translate(56.659 7.001)">
          <path
            fill="#f19920"
            d="M206.376,314.036a.837.837,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v.778a5.017,5.017,0,0,0,1.556.233h2.334a1.561,1.561,0,0,1,1.556,1.556h0a.78.78,0,0,0,.778.778.735.735,0,0,1,.778.778v.778h2.334v-.778A.78.78,0,0,0,206.376,314.036Z"
            transform="translate(-197.818 -296.92)"
          />
          <path
            fill="#f19920"
            d="M454.6,105.116v3.112a.367.367,0,0,1-.389.389h0a.367.367,0,0,1-.389-.389v-3.112a.367.367,0,0,1,.389-.389h0A.368.368,0,0,1,454.6,105.116Z"
            transform="translate(-436.703 -104.727)"
          />
        </g>
        <g transform="translate(51.213 -0.001)">
          <path
            fill="#f6b545"
            d="M139.636,46.545v.778h10.892a1.561,1.561,0,0,1,1.556,1.556V58.993c0,3.034-1.634,5.446-4.668,5.446h2.334a5.413,5.413,0,0,0,5.446-5.446V46.545Z"
            transform="translate(-138.08 -43.433)"
          />
          <path
            fill="#f6b545"
            d="M133.479,3.111h-15.56a1.561,1.561,0,0,1-1.556-1.556h0A1.561,1.561,0,0,1,117.919,0h15.56a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,133.479,3.111Z"
            transform="translate(-116.363 0.001)"
          />
        </g>
        <path
          fill="#f19920"
          d="M133.48,0h0a1.561,1.561,0,0,1-1.556,1.556h-15.56a1.561,1.561,0,0,0,1.556,1.556H133.4a1.665,1.665,0,0,0,1.634-1.323A1.576,1.576,0,0,0,133.48,0Z"
          transform="translate(-65.151 -0.001)"
        />
        <g transform="translate(54.325 5.445)">
          <path
            fill="#ffe27a"
            d="M163.687,87.679h0a.735.735,0,0,1-.778-.778V82.233a.735.735,0,0,1,.778-.778h0a.735.735,0,0,1,.778.778V86.9A.735.735,0,0,1,163.687,87.679Z"
            transform="translate(-162.909 -81.455)"
          />
          <circle
            fill="#ffe27a"
            cx="0.778"
            cy="0.778"
            r="0.778"
            transform="translate(0 7.002)"
          />
        </g>
        <path
          fill="#847f8e"
          d="M117.919,384a1.561,1.561,0,0,0-1.556,1.556v3.89h1.556Z"
          transform="translate(-65.15 -358.327)"
        />
      </g>
    </CupSvg>
  );
}

const PlainSvg = styled.svg`
  display: inline-block;
  width: 16px;
  height: auto;
  fill: ${({ theme }) => theme.foreground};
`;

export function PlainCupIcon(props: Props) {
  return (
    <PlainSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20" {...props}>
      <g transform="translate(-40.735 5.869)">
        <path
          d="M-2295.042-119.769a.49.49,0,0,1-.445-.467v-.934a.49.49,0,0,1,.445-.467h.444v-2.222a.9.9,0,0,1,.889-.909h1.333v-.39a.439.439,0,0,1,.445-.482.439.439,0,0,0,.445-.482v-1.5a3.119,3.119,0,0,1-2.1-2.144h-.7a2.064,2.064,0,0,1-1.555-.681l-.755-.773a2.087,2.087,0,0,1-.667-1.591v-2.864a1.325,1.325,0,0,1,1.334-1.364h2.222v-.839a.921.921,0,0,1-.889-.944.921.921,0,0,1,.889-.944h8.888a.921.921,0,0,1,.889.944.92.92,0,0,1-.889.944v.839h2.222a1.325,1.325,0,0,1,1.334,1.364v2.864a2.157,2.157,0,0,1-.667,1.591l-.756.773a2,2,0,0,1-1.555.681h-.7a3.117,3.117,0,0,1-2.1,2.144v1.5a.438.438,0,0,0,.444.482.439.439,0,0,1,.445.482v.39h1.333a.9.9,0,0,1,.889.909v2.222h.444a.491.491,0,0,1,.444.467v.934a.491.491,0,0,1-.444.467Zm10.8-10.909a1.2,1.2,0,0,0,.933-.409l.756-.773a1.324,1.324,0,0,0,.4-.954v-2.864a.425.425,0,0,0-.444-.455h-2.222v5.455Zm-12.133-5v2.864a1.251,1.251,0,0,0,.4.954l.755.773a1.266,1.266,0,0,0,.933.409h.578v-5.455h-2.222A.425.425,0,0,0-2296.376-135.678Z"
          transform="translate(2338 133.9)"
        />
      </g>
    </PlainSvg>
  );
}

const TimerSvg = styled.svg.attrs({
  style: ({ width, height }) => ({
    width,
    height
  })
})`
  width: 1em;
  height: auto;
  margin-right: 0.5em;
  font-size: 8px;
`;

export function TimerIcon(props: Props) {
  return (
    <TimerSvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 10.002"
      fill="#ffffff"
      {...props}
    >
      <path
        d="M1238-12043.681a3.976,3.976,0,0,1,1.175-2.825l-.448-.632a.245.245,0,0,1,.059-.345l.659-.468a.25.25,0,0,1,.348.062l.445.625a3.954,3.954,0,0,1,1.131-.358v-.257a.3.3,0,0,0-.3-.3h-.165a.3.3,0,0,1-.3-.3v-.911a.3.3,0,0,1,.3-.3h2.193a.3.3,0,0,1,.3.3v.911a.3.3,0,0,1-.3.3h-.165a.3.3,0,0,0-.3.3v.257a3.924,3.924,0,0,1,1.06.323l.449-.632a.25.25,0,0,1,.348-.06l.659.468a.246.246,0,0,1,.061.345l-.439.618a3.975,3.975,0,0,1,1.231,2.879,4,4,0,0,1-4,3.993A4,4,0,0,1,1238-12043.681Zm.96,0a3.038,3.038,0,0,0,3.04,3.033,3.04,3.04,0,0,0,3.041-3.033,3.043,3.043,0,0,0-3.041-3.035A3.041,3.041,0,0,0,1238.962-12043.681Zm3.02-.021v-2.481h.02a2.508,2.508,0,0,1,2.507,2.481Z"
        transform="translate(-1238.001 12049.689)"
      />
    </TimerSvg>
  );
}

export const PaginationArrow = () => <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 6.167 10"
  fill="currentColor"
  width="6.167"
  height="10"
>
  <path
    d="M87.767,180.867,86.6,179.7l-5,5,5,5,1.167-1.167L83.933,184.7Z"
    transform="translate(-81.599 -179.7)"
  />
</svg>;


// WEBPACK FOOTER //
// ./src/components/Tournaments/Icons.js